export default __webpack_public_path__ + "static/media/woman1.f97c5cd4.jpg";